import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { TrayShapeId } from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { allGlasses } from './common/materialGroups';
import additionalDataFactory from './common/fieldsAdditionalData';

const WindowsForm: IForm = {
    formId       : PublishedFormId.GlassShape,
    type         : FormTypeId.GlassAndMirror,
    thumbnailURL : '/resized-images/forms/glassShape.jpg',
    imagesURLs   : [
        '/resized-images/forms/description/glassPainting/glassShape.jpg',
        '/resized-images/forms/description/glassPainting/glassShape.jpg',
    ],
    fieldsOrder: [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.ShapeDimension,
        IFormFieldKey.Material,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        shapeDimension: {
            shape: {
                value   : undefined,
                options : [
                    TrayShapeId.TraysSquare,
                    TrayShapeId.TrayRectangle,
                    TrayShapeId.TrayRound,
                    TrayShapeId.TrayOval,
                ],
                required: true,
            },
            dimension: {
                options: {
                    [TrayShapeId.TraysSquare]: {
                        [FieldDimensionId.Width]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 50, max: 1000 },
                            required     : true,
                            defaultValue : 200,
                        },
                        [FieldDimensionId.Thickness]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 1,
                            range        : { min: 3, max: 10 },
                            required     : true,
                            defaultValue : 4,
                        },
                    },
                    [TrayShapeId.TrayRectangle]: {
                        [FieldDimensionId.Length]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 50, max: 1000 },
                            required     : true,
                            defaultValue : 200,
                        },
                        [FieldDimensionId.Width]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 50, max: 1000 },
                            required     : true,
                            defaultValue : 200,
                        },
                        [FieldDimensionId.Thickness]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 1,
                            range        : { min: 3, max: 10 },
                            required     : true,
                            defaultValue : 4,
                        },
                    },
                    [TrayShapeId.TrayRound]: {
                        [FieldDimensionId.Diameter]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 50, max: 1000 },
                            required     : true,
                            defaultValue : 200,
                        },
                        [FieldDimensionId.Thickness]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 1,
                            range        : { min: 3, max: 10 },
                            required     : true,
                            defaultValue : 4,
                        },
                    },
                    [TrayShapeId.TrayOval]: {
                        [FieldDimensionId.Length]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 50, max: 1000 },
                            required     : true,
                            defaultValue : 200,
                        },
                        [FieldDimensionId.Width]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 50, max: 1000 },
                            required     : true,
                            defaultValue : 200,
                        },
                        [FieldDimensionId.Thickness]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 1,
                            range        : { min: 3, max: 10 },
                            required     : true,
                            defaultValue : 4,
                        },
                    },
                },
            },
        },
        material: {
            material: {
                value   : undefined,
                options : [
                    ...allGlasses,
                    MaterialId.GlassVitroceramic,
                ],
                required: true,
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 500,
            budgetMax          : 6000,
            budgetDefaultValue : 1000,
        }),
        contact: fieldsContact,
    },
};

export default WindowsForm;
